import React from "react";
import PropTypes from "prop-types";
import SvgInline from "../SvgInline";
import classnames from "classnames";
import { NavLink } from "react-router-dom";

const NavItem = ({ icon, children, active, href, notification, onClick }) => (
  <NavLink className={classnames("nav-menu__item")} to={href} onClick={onClick}>
    <SvgInline src={icon} className="nav-menu__icon" />
    {children}
    {notification > 0 && (
      <span className="nav-menu__notification">{notification}</span>
    )}
  </NavLink>
);

NavItem.propTypes = {
  icon: PropTypes.string,
  active: PropTypes.bool,
  href: PropTypes.string,
  notification: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default NavItem;
